var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RelatedCollectionsCard',{attrs:{"overrides":_vm.relatedCollections,"entity-uris":_vm.entityUris,"data-qa":"related collections"},on:{"entitiesFromUrisFetched":_vm.handleRelatedCollectionsCardFetched}})
}
var staticRenderFns = []

export { render, staticRenderFns }